import Marquee from "react-fast-marquee";
import { useLang } from "./LanguageContext";
import { Reveal } from "./Reveal";
import { PARTNERS } from "./content";

export const Partners = () => {
  const { t } = useLang();

  return (
    <section className="relative py-16 md:py-20 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
            <div>
              <span className="text-xs font-bold tracking-[0.25em] uppercase text-[#00f0ff]">
                {t.partners.overline}
              </span>
              <h2 className="font-display font-bold text-2xl md:text-3xl tracking-tight text-white mt-3 max-w-xl leading-tight">
                {t.partners.title}
              </h2>
            </div>
          </div>
        </Reveal>
      </div>

      <Marquee speed={30} gradient gradientColor="#050505" gradientWidth={80} pauseOnHover autoFill>
        {PARTNERS.map((name, i) => (
          <div
            key={i}
            data-testid={`partner-${i}`}
            className="group mx-3 flex items-center h-14 px-7 border border-white/10 bg-white/[0.02] hover:border-[#ccff00]/50 hover:bg-white/[0.04] transition-colors"
          >
            <span className="font-display font-semibold text-base md:text-lg tracking-tight text-zinc-400 group-hover:text-white transition-colors whitespace-nowrap">
              {name}
            </span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
